require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-oberschuetzen.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-oberschuetzen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-oberschuetzen!./.cache/json/betreuungseinrichtungen-oberwart-oberschuetzen.json
// module id = 1018
// module chunks = 231608221292675